document.addEventListener("DOMContentLoaded", function () {
  const header = document.getElementById("header-section");
  const hasCustomBanner = document.querySelector(".custom-banner");

  if (hasCustomBanner) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    });
  } else {
    header.classList.add("scrolled");
  }

  document.body.addEventListener('click', function(event) {
    // Using .closest() to check if the click is inside a subscription option
    const subscriptionOption = event.target.closest('.sls-one-time, .sls-subscription-option-wrapper');
    
    if (subscriptionOption) {
      // Delay to allow the subscription app to update the DOM
      setTimeout(function() {
        // Find all flickity carousels on the page
        const carousels = document.querySelectorAll('.flickity__section');
        carousels.forEach(carousel => {
          const flkty = Flickity.data(carousel);
          if (flkty) {
            flkty.resize();
          }
        });
      }, 300);
    }
  });
});
